const mondelezAPI = {
  productURL: "https://dev-api-abstract.mdlzapps.cloud/product",
  recipeURL: "https://dev-api-abstract.mdlzapps.cloud/recipe",
  recipesList: "",
  sectorID: "21136",
  stockURL: "https://clientapi.gcs-web.com/data/b68f5ddc-99e1-4b10-8f04-e3f503ff54a7/Quotes"
}


const productIDs = [95, 96]

module.exports = { mondelezAPI, productIDs }
